import type { CorrectionReason } from '@/lib/api/types';
import { AttributeRow } from './AttributeRow';
import type { AttributeView } from './review-model';

interface FieldListProps {
  attributes: AttributeView[];
  assetKeys: string[];
  drafts: Record<string, string>;
  reasons: Record<string, CorrectionReason>;
  disabled: boolean;
  onDraft: (name: string, value: string | undefined) => void;
  onReason: (name: string, reason: CorrectionReason | undefined) => void;
}

/**
 * The Fields tab of the result screen: every attribute of the item
 * standard in one list, with the required ones still empty pinned first
 * (`buildAttributes`). The list is the part of the screen that scrolls, so
 * a fifth field never pushes the pinned actions off the bottom.
 */
export function FieldList({ attributes, assetKeys, drafts, reasons, disabled, onDraft, onReason }: FieldListProps) {
  if (attributes.length === 0) return <p className="py-3 text-sm text-muted">No fields</p>;
  return (
    <ul className="flex flex-col">
      {attributes.map((attribute) => (
        <AttributeRow
          key={attribute.name}
          attribute={attribute}
          assetKeys={assetKeys}
          draft={drafts[attribute.name]}
          reason={reasons[attribute.name]}
          disabled={disabled}
          onDraft={(value) => onDraft(attribute.name, value)}
          onReason={(reason) => onReason(attribute.name, reason)}
        />
      ))}
    </ul>
  );
}
